export const FONT_THEME = {
  // ── Core ──────────────────────────────────────────────────────────────────
  MODERN: {
    HEADING: "'Bodoni Moda SC', serif",
    BODY: "'Inter', sans-serif",
    ACCENT: "'Montserrat', sans-serif",
  },
  CLASSIC: {
    HEADING: "'Inter', sans-serif",
    BODY: "'Inter', sans-serif",
    ACCENT: "'Montserrat', sans-serif",
  },
  ELEGANT: {
    HEADING: "'Great Vibes', cursive",
    BODY: "'Cormorant Garamond', serif",
    ACCENT: "'Tangerine', cursive",
  },
  FRIENDLY: {
    HEADING: "'Bagel Fat One', cursive",
    BODY: "'Nunito', sans-serif",
    ACCENT: "'Comfortaa', cursive",
  },

  // ── Script / Calligraphy ──────────────────────────────────────────────────
  /** Upscale signature feel — great for salons, spas, beauty studios */
  SIGNATURE: {
    HEADING: "'Mr Dafoe', cursive",
    BODY: "'Lato', sans-serif",
    ACCENT: "'Raleway', sans-serif",
  },
  /** Celebration / event feel — nail bars, bridal, seasonal pop-ups */
  FESTIVE: {
    HEADING: "'Festive', cursive",
    BODY: "'Cormorant Garamond', serif",
    ACCENT: "'Cinzel Decorative', serif",
  },
  /** Painterly brush script — art studios, creative services */
  SPLASH: {
    HEADING: "'Splash', cursive",
    BODY: "'Nunito', sans-serif",
    ACCENT: "'Comfortaa', cursive",
  },

  // ── Editorial / Serif ─────────────────────────────────────────────────────
  /** Classic magazine luxury — luxury spas, high-end barbershops, medispas */
  EDITORIAL: {
    HEADING: "'Playfair Display', serif",
    BODY: "'Lora', serif",
    ACCENT: "'Montserrat', sans-serif",
  },

  // ── Vintage / Themed ──────────────────────────────────────────────────────
  /** Old West frontier — traditional barbershops, tattoo studios */
  WESTERN: {
    HEADING: "'Rye', serif",
    BODY: "'Libre Baskerville', serif",
    ACCENT: "'Josefin Slab', serif",
  },
  /** Retro bold marquee — vintage barbershops, 50s/60s-inspired shops */
  RETRO: {
    HEADING: "'Fascinate', cursive",
    BODY: "'Raleway', sans-serif",
    ACCENT: "'Oswald', sans-serif",
  },
  /** Dark blackletter — tattoo parlors, alt/metal-inspired studios */
  GOTHIC: {
    HEADING: "'UnifrakturMaguntia', cursive",
    BODY: "'EB Garamond', serif",
    ACCENT: "'Cinzel', serif",
  },

  // ── Artsy / Handmade ──────────────────────────────────────────────────────
  /** Sketchy hand-drawn — artisan studios, rustic wellness, craft shops */
  SKETCH: {
    HEADING: "'Cabin Sketch', cursive",
    BODY: "'Cabin', sans-serif",
    ACCENT: "'Josefin Sans', sans-serif",
  },
  /** Colorful mosaic tiles — creative studios, nail art, kids' salons */
  MOSAIC: {
    HEADING: "'Palette Mosaic', cursive",
    BODY: "'DM Sans', sans-serif",
    ACCENT: "'Nunito', sans-serif",
  },

  // ── Urban / Bold ──────────────────────────────────────────────────────────
  /** Street art spray paint — urban barbershops, graffiti-inspired studios */
  SPRAY: {
    HEADING: "'Rubik Spray Paint', cursive",
    BODY: "'Rubik', sans-serif",
    ACCENT: "'Space Grotesk', sans-serif",
  },
  /** Digital glitch — tech-forward, cyber-aesthetic, edgy studios */
  GLITCH: {
    HEADING: "'Rubik Glitch', cursive",
    BODY: "'Rubik', sans-serif",
    ACCENT: "'Space Grotesk', sans-serif",
  },

  // ── Pixel / Digital ───────────────────────────────────────────────────────
  /** Retro 12px pixel — gaming lounges, retro-themed studios */
  PIXEL: {
    HEADING: "'Jacquard 12', cursive",
    BODY: "'VT323', monospace",
    ACCENT: "'Space Mono', monospace",
  },
  /** Athletic pixel jersey — sports coaching, fitness, active lifestyle */
  JERSEY: {
    HEADING: "'Jersey 15', cursive",
    BODY: "'Bebas Neue', cursive",
    ACCENT: "'Oswald', sans-serif",
  },
  /** 24px arcade cabinet — retro gaming, esports venues */
  ARCADE: {
    HEADING: "'Jacquard 24', cursive",
    BODY: "'Share Tech Mono', monospace",
    ACCENT: "'VT323', monospace",
  },
};

/** Font keys available on the Basic plan. Standard+ fonts are hidden until that tier launches. */
export const BASIC_PLAN_FONT_KEYS = new Set<keyof typeof FONT_THEME>([
  'CLASSIC', 'MODERN', 'ELEGANT', 'FRIENDLY', 'SIGNATURE', 'EDITORIAL',
]);

/** Additional expressive font themes available to Standard and Premium businesses. */
export const STANDARD_PLAN_FONT_KEYS = new Set<keyof typeof FONT_THEME>([
  'FESTIVE',
  'SPLASH',
  'WESTERN',
  'RETRO',
  'GOTHIC',
  'SKETCH',
  'MOSAIC',
  'SPRAY',
  'GLITCH',
  'PIXEL',
  'JERSEY',
  'ARCADE',
]);